<template>
  <div class="clock">
    <div class="clock-numbers">
      <span class="clock-hours" style="font-weight: 100">{{
        countdownHours
      }}</span>
      <span class="clock-mins-dots">:</span>
      <span class="clock-mins">{{ countdownMins }}</span>
      <span class="clock-secs-dots">:</span>
      <span class="clock-secs" style="font-weight: bold">{{
        countdownSecs
      }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "clock",
  props: {
    fontSize: {
      type: String,
      default: "28px",
    },
  },
  computed: {
    countdownHours() {
      let hrs = Math.floor(
        (this.countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      if (hrs < 0) {
        hrs = "00";
      } else if (hrs < 10) {
        hrs = "0" + hrs;
      }
      return hrs;
    },
    countdownMins() {
      let mins = Math.floor((this.countdown % (1000 * 60 * 60)) / (1000 * 60));
      if (mins < 0) {
        mins = "00";
      } else if (mins < 10) {
        mins = "0" + mins;
      }
      return mins;
    },
    countdownSecs() {
      let secs = Math.floor((this.countdown % (1000 * 60)) / 1000);
      if (secs < 0) {
        secs = "00";
      } else if (secs < 10) {
        secs = "0" + secs;
      }
      return secs;
    },
    ...mapState(["countdown"]),
  },
};
</script>

<style lang="less">
.clock {
  position: relative;
  width: 100%;
}

.clock-numbers {
  text-align: center;
  width: 100%;
}

.small {
  font-size: 28px;

  .clock-numbers {
    position: absolute;
    bottom: -9px;
  }
}

.large {
  font-size: 80px;
}
</style>      
        